import React, { useContext, useEffect, useState } from "react";
import { Layout } from "flexlayout-react";
import "flexlayout-react/style/light.css";
import { LocalStoreContext } from "../store/LocalStore";
import { StoreContext } from "../../../store/Store";
import { LayoutContext } from "../store/LayoutContext";
import { GlobalRefContext } from "../../../store/GlobalRefs";
import { RefContext } from "../store/RefContext";
import { actionTypes as lactionTypes } from "../store/storeTypes";
import { fairvalueData } from "../../../api/s3";
import {
  onAction,
  factory,
  layoutModelChange,
  onRenderTabSet,
} from "./layoutFunctions";
import "../../../layout/layoutstyle.css";

export const FairValueLayout = () => {
  const [store] = useContext(StoreContext);
  const [lstore, ldispatch] = useContext(LocalStoreContext);
  const [layoutState, setLayoutState] = useContext(LayoutContext);
  const refs = useContext(RefContext);
  const grefs = useContext(GlobalRefContext);
  const [modelDate, setModelDate] = useState();

  const { auth, debug } = store;

  if (debug) {
    console.log("FairValueLayout");
  }

  if (lstore) {
    //do nothing
  }

  useEffect(() => {
    let isCancelled = false;

    const asyncfunction = async () => {
      ldispatch({ type: lactionTypes.SET_LOADING, payload: true });
      const newState = {
        rawdata: [],
      };

      const sdata = await fairvalueData(auth, grefs.tickerStorage.current);
      if (sdata && sdata.length > 0) {
        newState.rawdata = sdata;
        setModelDate(sdata[0].ModelDate);
      }

      if (!isCancelled) {
        ldispatch({ type: lactionTypes.SET_FAIRVALUE, payload: newState });
        ldispatch({ type: lactionTypes.SET_LOADING, payload: false });
      }
    };
    asyncfunction();

    return () => {
      isCancelled = true;
    };
  }, [auth, ldispatch, grefs.tickerStorage]);

  if (layoutState.model && modelDate) {
    return (
      <Layout
        ref={layoutState.layout}
        model={layoutState.model}
        factory={(node) => factory(node, modelDate)}
        onRenderTabSet={(tabSetNode) => onRenderTabSet(tabSetNode, refs)}
        onModelChange={(model) =>
          layoutModelChange(model, layoutState, setLayoutState, grefs)
        }
        onAction={(action) => onAction(action, layoutState)}
      />
    );
  } else return null;
};
